import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import styled from "@mui/material/styles/styled";
import { DataGridProps } from "@mui/x-data-grid";
import { GridToolbarContainer } from "@mui/x-data-grid/components/containers/GridToolbarContainer";
import { GridToolbarQuickFilter, GridToolbarQuickFilterProps } from "@mui/x-data-grid/components/toolbar/GridToolbarQuickFilter";
import { DataGrid } from "@mui/x-data-grid/DataGrid/DataGrid";

export const StyledDataGrid = styled((props: DataGridProps) => (<DataGrid {...props} />))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 12,
  boxShadow: 'none',
  backgroundColor: theme.palette.background.paper,

  '& .MuiDataGrid-cell': {
    borderBottom: `1px solid ${theme.palette.divider}`,
    fontSize: '0.875rem',
    color: theme.palette.text.primary,
    transition: 'background-color 0.2s ease',
  },
  '& .MuiDataGrid-columnHeaders': {
    borderBottom: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.mode === 'dark' ? '#18191a' : '#f8fafc',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    color: theme.palette.text.secondary,
  },
  '& .MuiDataGrid-footerContainer': {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  '& .MuiDataGrid-row': {
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: theme.palette.mode === 'dark'
        ? 'rgba(94,106,210,0.06)'
        : '#f1f5f9',
      cursor: 'pointer',
    },
  },
  '& .MuiDataGrid-selectedRowCount': {
    fontSize: '0.8125rem',
    color: theme.palette.text.secondary,
  },
}));

export const CustomQuickFilter = styled((props: GridToolbarQuickFilterProps) => (
  <GridToolbarQuickFilter
    {...props}
    variant="outlined"
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <SearchIcon sx={{ fontSize: 18, color: 'text.disabled' }} />
        </InputAdornment>
      ),
    }}
  />
))(({ theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  padding: 0,
  marginRight: theme.spacing(1),
  flex: 1,
  maxHeight: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: 25,
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.04)' : '#f8fafc',
    transition: 'box-shadow 0.2s ease, border-color 0.2s ease',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#e2e8f0',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.primary.light,
    },
    '&.Mui-focused': {
      boxShadow: `0 0 0 3px ${theme.palette.mode === 'dark' ? 'rgba(94,106,210,0.2)' : 'rgba(94,106,210,0.12)'}`,
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: '1.5px',
      },
    },
  },
  '& .MuiInputBase-input': {
    padding: theme.spacing(0.875, 1.5),
    fontSize: '0.875rem',
    paddingLeft: theme.spacing(0.5),
  },
}));

export const CustomToolbarContainer = styled(GridToolbarContainer)({
  display: 'flex',
  justifyContent: 'space-between',
});
